import React from 'react';
import {Divider, Accordion, AccordionSummary, AccordionDetails} from '@material-ui/core';
import {ProcedureStepsCtx, ProcedureStepFilesCtx, ProcedureStepFilesProvider} from 'components/dataProviders/procedureSteps';
// import {Edit, Archive, Unarchive} from '@material-ui/icons';
import {Edit} from '@material-ui/icons';
import {makeStyles} from '@material-ui/core/styles';
import FilesList from 'components/files/FilesList';
import EditDialog from './edit';
import clsx from 'clsx';
import ARPoint from 'components/procedures/anchors'
import {ItemDrawer} from 'components/procedures/items';
import TemplateField from './templateField';

// import {FormControl} from 'components/core';

const styles = makeStyles((theme) => ({
  infoHeader: {
    fontSize: '13px',
    FontWeight: 400,
    color: theme.palette.text.primary,
    marginBottom: 3
  },
  infoRoot: {
    // padding: 25
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: -16,
    backgroundColor: theme.palette.input.background,
    minHeight: "calc(100% + 16px)"
  },
  stepAccordion: {
    '&.Mui-expanded':
    {
      margin: 16
    }
  },
  accordionContent: {
    flexDirection: 'column'
  },
  infoBlock: {
    marginTop: 25
  },
  stepTitle: {
    fontSize: '18px',
    FontWeight: 800,
    color: theme.palette.text.secondary
  },
  infoLabel: {
    marginBottom: 15
  },
  infoField: {
    fontSize: '15px',
    FontWeight: 600,
    color: theme.palette.text.secondary,
    whiteSpace: "pre-line"
  },
  itemsBlock: {
    marginBottom: 25,
    display: 'inline-flex',
    flexWrap: "wrap",
    '& > *': {
      margin: 5
    }
  },
  item: {
    // width: 30,
    // height: 30
  },
  verificationField: {
    display: "flex",
    flexDirection: "row",
    
  },
  verificationType: {
    padding: 5,
    marginTop: 5,
    backgroundColor: theme.palette.input.background,
    borderRadius: 5,
    minWidth:110,
    textAlign: "center",
    "&.ar_activation":
    {
      width: "100%"
    }
  },
  verificationName: {
    padding: 5,
    marginTop: 5,
    fontWeight: 300
  },
  filesList: {
    padding: 0
  }
}), {name: "RaymanProcedures"});

const verificationTypes = {
  "text": "Texto corto",
  "textarea": "Texto largo",
  "bool_slider": "Confirmación",
  "ar_activation": "Uso de Realidad Aumentada",
  "picture": "Fotografía",
};

function ProcedureStepWrapper({procedureID, stepID, stepIndex})
{
  return <ProcedureStepFilesProvider procedureID={procedureID} stepID={stepID}>
    <ProcedureStep stepID={stepID} stepIndex={stepIndex} />
  </ProcedureStepFilesProvider>
}

function ProcedureStep({procedureID, stepID, stepIndex})
{
  const classes = styles();
  const stepsCtx = React.useContext(ProcedureStepsCtx);
  const filesCtx = React.useContext(ProcedureStepFilesCtx);
  const step = stepsCtx.data.indexed[stepID];

  return <Accordion className={classes.stepAccordion}>

    {/* <div className={classes.stepRoot}> */}
    <AccordionSummary classes={{content: classes.accordionContent}} >
      <div className={classes.infoHeader}>Paso {stepIndex}</div>
      <div className={classes.infoBlock}>
        <div className={classes.stepTitle}>{step.name}</div>
      </div>
    </AccordionSummary>
    <AccordionDetails className={classes.accordionContent}>
      { step.items.length > 0 && 
        <div className={classes.itemsBlock}>{step.items.map((itemID) => <ItemDrawer itemID={itemID} key={itemID} className={classes.item} />)}</div>
      }
      { step.description && 
        <div className={classes.infoField}>{step.description}</div>
      }
      {step.templateFields.map((field) => {
        if(field.value) return <TemplateField classes={classes} field={field} />
        else return null;
      })}
      <br />
     {step.verifications && step.verifications.length > 0 ? 
        <div className={classes.infoPair} key={"verifications"}>
          <div className={classes.infoHeader}>Verificaciones en tareas</div>
          <div className={classes.infoField}>
          {
            step.verifications.map((verification, index) => {
              return <div className={classes.verificationField} key={index}>
                <div className={clsx(classes.verificationType, verification.verificationType)}>{verificationTypes[verification.verificationType]}</div>
                {verification.verificationType !== "ar_activation" && <div className={classes.verificationName}>{verification.name}</div>}
              </div>
            })
          }
          </div>
        </div>
      : null }
    
      <br />
      { step.anchorID && 
        <div className={classes.infoBlock}>
          <div className={classes.infoLabel}>Realidad Aumentada</div>
          <div className={classes.infoField}><ARPoint anchorID={step.anchorID} /></div>
        </div>
      }
      { filesCtx.data.array.length > 0 && 
        <div className={classes.infoBlock}>
          <div className={classes.infoLabel}>Archivos</div>
          <div className={classes.infoField}><FilesList className={classes.filesList} context={ProcedureStepFilesCtx} /></div>
        </div>
      }
    </AccordionDetails>
    {/* </div> */}
  </Accordion>
}


export default function ProcedureSteps({procedureID})
{
    const classes = styles();
    const stepsCtx = React.useContext(ProcedureStepsCtx);

    if(!procedureID) return null;
    
    return <div className={classes.infoRoot}>
      {stepsCtx.data.array.map((step, index) => <React.Fragment key={step.stepID}><ProcedureStepWrapper procedureID={procedureID} stepID={step.stepID} key={step.stepID} stepIndex={index+1} />{/* <Divider /> */}</React.Fragment>)}
    </div>
}